module.exports = {
      id: "palo-bangla-usage",
      viewBox: "0 0 230 55",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#palo-bangla",
      toString: function () {
        return this.url;
      }
    }